import Question from "./question";

export default class QuestionResult {
    public questionId: number = 1;
    public isCorrect: boolean = false;

    public shiwakeLeft: string[] = ["", "", "", ""]
    public shiwakeRight: string[] = ["", "", "", ""]
    public priceLeft: number[] | undefined[] | string[] = [undefined, undefined, undefined, undefined]
    public priceRight: number[] | undefined[] | string[] = [undefined, undefined, undefined, undefined]

    public isCorrectArr: string = ""
    public score: number = 0
    public alreadyAnswer: boolean = false
}